/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlIntegrationMetadataConfigCustomFieldV2
 */
export interface ControlIntegrationMetadataConfigCustomFieldV2 {
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    advancedOption: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    display: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    hidden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    nonEditable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    required: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    validationMaxLength: number;
    /**
     * 
     * @type {number}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    validationMinLength: number;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationMetadataConfigCustomFieldV2
     */
    validationPattern: string;
}

/**
 * Check if a given object implements the ControlIntegrationMetadataConfigCustomFieldV2 interface.
 */
export function instanceOfControlIntegrationMetadataConfigCustomFieldV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "advancedOption" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "display" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "validationMaxLength" in value;
    isInstance = isInstance && "validationMinLength" in value;
    isInstance = isInstance && "validationPattern" in value;

    return isInstance;
}

export function ControlIntegrationMetadataConfigCustomFieldV2FromJSON(json: any): ControlIntegrationMetadataConfigCustomFieldV2 {
    return ControlIntegrationMetadataConfigCustomFieldV2FromJSONTyped(json, false);
}

export function ControlIntegrationMetadataConfigCustomFieldV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationMetadataConfigCustomFieldV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'advancedOption': json['advancedOption'],
        'description': json['description'],
        'display': json['display'],
        'hidden': !exists(json, 'hidden') ? undefined : json['hidden'],
        'nonEditable': !exists(json, 'nonEditable') ? undefined : json['nonEditable'],
        'required': json['required'],
        'slug': json['slug'],
        'source': json['source'],
        'type': json['type'],
        'validationMaxLength': json['validationMaxLength'],
        'validationMinLength': json['validationMinLength'],
        'validationPattern': json['validationPattern'],
    };
}

export function ControlIntegrationMetadataConfigCustomFieldV2ToJSON(value?: ControlIntegrationMetadataConfigCustomFieldV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'advancedOption': value.advancedOption,
        'description': value.description,
        'display': value.display,
        'hidden': value.hidden,
        'nonEditable': value.nonEditable,
        'required': value.required,
        'slug': value.slug,
        'source': value.source,
        'type': value.type,
        'validationMaxLength': value.validationMaxLength,
        'validationMinLength': value.validationMinLength,
        'validationPattern': value.validationPattern,
    };
}

